// src/api/incomeTaxSettings.ts
import api from "./api";

export interface IncomeTaxSettings {
  id: string;
  username: string;
  is_active: boolean;
  // GET never returns the password — this only says whether one is stored.
  has_password: boolean;
  updated_at: string | null;
}

export interface IncomeTaxSettingsGetResponse {
  settings: IncomeTaxSettings | null;
}

export interface IncomeTaxSettingsPayload {
  username?: string;
  // Omit to keep the currently stored password unchanged.
  password?: string;
}

export interface IncomeTaxCredentials {
  username: string;
  password: string;
}

export interface TdsSummaryResponse {
  year: number;
  month: number;
  section: string | null;
  tdsAmount: number;
}

export const incomeTaxSettingsApi = {
  get: () => api.get<IncomeTaxSettingsGetResponse>(`/incometax-settings`),
  save: (payload: IncomeTaxSettingsPayload) => api.post(`/incometax-settings`, payload),
  // Plaintext credentials — only called when handing off to the extension.
  getCredentials: () => api.get<IncomeTaxCredentials>(`/incometax-settings/credentials`),
  // Total salary TDS for one payroll month, from approved payslips only —
  // same figure the Payroll Reports Statutory tab shows.
  getTdsSummary: (year: number, month: number, section: string) =>
    api.get<TdsSummaryResponse>(`/incometax-settings/tds-summary`, { params: { year, month, section } }),
};
